module.exports = __webpack_public_path__ + "static/media/recharging-your-battery-large.cbc0cc4e.png";